import { gql } from "@apollo/client"
import {
  PACKAGING_MATERIAL_FRAG,
  SCHEDULE_LIST_FRAG,
  TRANSPORT_DETAIL_FRAG,
} from "./scheduling.fragments.gql"

// Mutations
export const ADD_SCHEDULE = gql`
  mutation NewScheduleMutation(
    $date: Date!
    $plotCommodityRequirements: [PlotCommodityRequirementInput!]
  ) {
    newSchedule(
      date: $date
      plotCommodityRequirements: $plotCommodityRequirements
    ) {
      schedules {
        ...ScheduleListFrag
      }
    }
  }
  ${SCHEDULE_LIST_FRAG}
`

export const DELETE_SCHEDULES = gql`
  mutation DeleteScheduleMutation($schedules: [Int]) {
    delSchedules(schedules: $schedules) {
      schedules
    }
  }
`

export const UPDATE_SCHEDULE = gql`
  mutation UpdateScheduleMutation($schedules: [UpdateScheduleRowInput!]) {
    updateSchedule(schedules: $schedules) {
      schedules {
        transportDetail {
          ...TransportDetailFrag
        }
        ...ScheduleListFrag
      }
    }
  }
  ${SCHEDULE_LIST_FRAG}
  ${TRANSPORT_DETAIL_FRAG}
`

// Transport Detail

export const ADD_UPDATE_TRANSPORT_DETAIL = gql`
  mutation AddTransportDetailMutation(
    $id: Int
    $schedule: Int!
    $advanceCost: Float
    $advancePaidBy: String
    $transportCost: Float
    $transportPaidBy: String
    $rejectionBourneBy: String
    $weightApplicable: String
    $acceptedDeduction: Float
    $remark: String
    $pricingDoneOn: String
    $standardDeduction: Float!
    $gradePrices: [GradePriceInput]
  ) {
    addTransportDetail(
      id: $id
      schedule: $schedule
      advanceCost: $advanceCost
      advancePaidBy: $advancePaidBy
      transportCost: $transportCost
      transportPaidBy: $transportPaidBy
      rejectionBourneBy: $rejectionBourneBy
      weightApplicable: $weightApplicable
      acceptedDeduction: $acceptedDeduction
      gradePrices: $gradePrices
      pricingDoneOn: $pricingDoneOn
      standardDeduction: $standardDeduction
      remark: $remark
    ) {
      detail {
        ...TransportDetailFrag
      }
    }
  }
  ${TRANSPORT_DETAIL_FRAG}
`
export const GENERATE_TRIPS = gql`
  mutation GenerateTripMutation(
    $date: Date!
    $schedules: [ID]
    $schedulesProcured: [SchedulesProcuredInput]
  ) {
    generateTrip(
      date: $date
      schedules: $schedules
      schedulesProcured: $schedulesProcured
    ) {
      trips {
        id
        bookings {
          id
          schedule {
            id
            isNotified
          }
        }
      }
    }
  }
`

export const MIGRATE_PLOT = gql`
  mutation MigratePlotMutation($fromDate: Date!, $toDate: Date!, $plot: Int!) {
    migratePlot(fromDate: $fromDate, toDate: $toDate, plot: $plot) {
      schedules {
        id
        date
      }
    }
  }
`
export const DELETE_PLOT_SCHEDULES = gql`
  mutation DelPlotSchedulesMutation($date: Date!, $plotCommodityId: Int!) {
    delPlotSchedules(date: $date, plotCommodityId: $plotCommodityId) {
      plotCommodityId
    }
  }
`

export const ADD_UPDATE_PACKAGING_MATERIAL = gql`
  mutation AddUpdatePackagingMaterialMutation(
    $id: Int
    $scheduleId: Int
    $pmSupervisorId: Int
    $areaInchargeId: Int
    $fieldSupervisorId: Int
    $packagingMaterialItems: [PackagingMaterialItemInput]
  ) {
    addUpdatePackagingMaterial(
      id: $id
      scheduleId: $scheduleId
      sendWhatsappApproval: false
      pmSupervisorId: $pmSupervisorId
      areaInchargeId: $areaInchargeId
      fieldSupervisorId: $fieldSupervisorId
      packagingMaterialItems: $packagingMaterialItems
    ) {
      packagingMaterial {
        ...PackagingMaterialFrag
      }
    }
  }
  ${PACKAGING_MATERIAL_FRAG}
`

export const SEND_PACKAGING_MATERIAL_WHATSAPP_APPROVAL = gql`
  mutation SendPackagingMaterialWhatsappApprovalMutation(
    $departmentId: Int
    $packagingMaterialId: Int
  ) {
    sendPackagingMaterialWhatsappApproval(
      departmentId: $departmentId
      packagingMaterialId: $packagingMaterialId
    ) {
      success
    }
  }
`
